export const START = 'start';
export const CARD = 'card';
export const SEPA = 'sepa';
